module.exports = __webpack_public_path__ + "media/win2.8fb75c98.wav";